import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { db, storage } from "@lib/firebase";
import {
  collection,
  addDoc,
  getDoc,
  doc,
  updateDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  limit,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useAuth } from "@context/AuthContext";
import { useNotification } from "../common/NotificationContext";
import { jsPDF } from "jspdf";
import { InputFieldRace } from "../common/InputFieldRace";
import { VoucherInput } from "../common/VoucherInput";
import { StepIndicator } from "../common/StepIndicator";
import { InputField, Button } from "@cakrawalajakarta/shared-components";
import { serverTimestamp } from "firebase/firestore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { useGoogleReCaptcha, GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const normalizeGender = (value) => {
  if (!value) return "";
  const lower = value.toLowerCase().trim();
  if (lower === "laki-laki" || lower === "pria" || lower === "male") return "Male";
  if (lower === "perempuan" || lower === "wanita" || lower === "female") return "Female";
  return value;
};

const FormPendaftaranContent = ({ labelColor = "text-slate-800" }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    title,
    price,
    foreignerPrice,
    eventId,
    collectionName: initialCollectionName,
  } = location.state || {};
  const { user, getIdToken } = useAuth();
  const { showNotification } = useNotification();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [formData, setFormData] = useState({
    namaDepan: "",
    namaBelakang: "",
    namaLengkap: "",
    email: "",
    telepon: "",
    nomorIdentitas: "",
    tanggalLahir: "",
    gender: "",
    negara: "Indonesia",
    provinsi: "",
    kota: "",
    alamat: "",
    kontakDarurat: "",
    namaKontakDarurat: "",
    hubunganKontakDarurat: "",
    bibName: "",
    golonganDarah: "",
    sizeJersey: "",
    performanceIndex: "",
    raceResultLink: "",
    teamName: "",
    participants: [
      {
        namaDepan: "",
        namaBelakang: "",
        bibName: "",
        telepon: "",
        nomorIdentitas: "",
        tanggalLahir: "",
        golonganDarah: "",
        sizeJersey: "",
        gender: "",
        negara: "Indonesia",
        provinsi: "",
        kota: "",
        alamat: "",
        kontakDarurat: "",
        namaKontakDarurat: "",
        hubunganKontakDarurat: "",
        performanceIndex: "",
        raceResultLink: "",
      },
      {
        namaDepan: "",
        namaBelakang: "",
        bibName: "",
        telepon: "",
        nomorIdentitas: "",
        tanggalLahir: "",
        golonganDarah: "",
        sizeJersey: "",
        gender: "",
        negara: "Indonesia",
        provinsi: "",
        kota: "",
        alamat: "",
        kontakDarurat: "",
        namaKontakDarurat: "",
        hubunganKontakDarurat: "",
        performanceIndex: "",
        raceResultLink: "",
      },
      {
        namaDepan: "",
        namaBelakang: "",
        bibName: "",
        telepon: "",
        nomorIdentitas: "",
        tanggalLahir: "",
        golonganDarah: "",
        sizeJersey: "",
        gender: "",
        negara: "Indonesia",
        provinsi: "",
        kota: "",
        alamat: "",
        kontakDarurat: "",
        namaKontakDarurat: "",
        hubunganKontakDarurat: "",
        performanceIndex: "",
        raceResultLink: "",
      },
    ],
  });

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [isSnapReady, setIsSnapReady] = useState(false);
  const [registrationStatus, setRegistrationStatus] = useState(null);
  const [transactionStatus, setTransactionStatus] = useState(null);
  const [snapToken, setSnapToken] = useState(null);
  const [orderId, setOrderId] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [voucherCode, setVoucherCode] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [finalPrice, setFinalPrice] = useState(price || 0);
  const [collectionName, setCollectionName] = useState(null);
  const [categoryName, setCategoryName] = useState(null);
  const [distance, setDistance] = useState(null);
  const [isDraftLoaded, setIsDraftLoaded] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);

  const isRoadToJOTR = eventId === "ROADTOJOTR2026";
  const normalizedCategoryName = String(categoryName || title || "").toUpperCase();
  const isFunRun5K = eventId === "FUNRUN5K2026" || normalizedCategoryName.includes("FUN RUN 5K CIBODAS");
  const isJotrMainEvent = eventId === "JOTR2026" || eventId === "JOTR";
  const isRaceEvent = isJotrMainEvent || isRoadToJOTR || isFunRun5K;
  const STEPS = isRoadToJOTR
    ? ["Participant Info", "Submission"]
    : ["Participant Info", "Waiver & Review", "Submission"];

  const handleNextStep = () => {
    // Basic validation before moving to next step
    if (currentStep === 1) {
       if (!formData.namaLengkap || !formData.email || !formData.telepon) {
           showNotification(
             "error", 
             "Please complete the main personal data.",
             "Close"
           );
           return;
       }

       if (isJotrMainEvent && !isFunRun5K) {
         const requiredJotrFields = [
           { field: "bibName", label: "Bib Name" },
           { field: "golonganDarah", label: "Blood Type" },
           { field: "sizeJersey", label: "Jersey Size" },
           { field: "raceResultLink", label: "STRAVA or Race Result Link" },
         ];

         const missingField = requiredJotrFields.find(
           (item) => !formData[item.field]
         );

         if (missingField) {
           showNotification(
             "error",
             `Please complete ${missingField.label} before continuing.`,
             "Close"
           );
           return;
         }
       } else if (isRoadToJOTR) {
         const requiredRoadFields = [
           { field: "bibName", label: "Bib Name" },
           { field: "golonganDarah", label: "Blood Type" },
           { field: "sizeJersey", label: "Jersey Size" },
         ];
         const missingField = requiredRoadFields.find((item) => !formData[item.field]);
         if (missingField) {
           showNotification("error", `Please complete ${missingField.label} before continuing.`, "Close");
           return;
         }
       }
    }
    setCurrentStep((prev) => Math.min(prev + 1, STEPS.length));
    window.scrollTo(0, 0);
  };

  const handlePrevStep = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
    window.scrollTo(0, 0);
  };

  const isGroupRegistration = eventId === "JOTR2026" && title.includes("Group");

  const isForeigner = isGroupRegistration
    ? formData.negara !== "Indonesia" ||
      formData.participants.some((p) => p.negara !== "Indonesia")
    : formData.negara !== "Indonesia";

  const waiverContent = isForeigner
    ? {
        title: "LETTER OF DECLARATION & WAIVER",
        checkboxLabel:
          "I have read and agree to the Statement & Release of Liability",
        pdfTitle: "LETTER OF DECLARATION",
        pdfNameLabel: "Name",
        pdfTeamLabel: "Team Name",
        pdfDateLabel: "Date",
        pdfClosing: "Sincerely,",
        pdfPageLabel: (page, total) => `Page ${page} of ${total}`,
        fileNamePrefix: "Statement_Letter",
        uiParagraphs: [
          "I declare that I have read and agreed to all the statements in this document, and I am consciously responsible for all risks that occur during and after the race.",
          "In connection with my participation in ",
          ", I consciously agree to the release of liability for any risks that occur.",
        ],
        uiList: [
          "I have read and agreed to all information related to the event, regulations, and other information related to ",
          "I declare that I am physically healthy to participate in the ",
          "I declare that any form of injury, illness, or physical disability that occurs before and/or after the race takes place, where I acknowledge such injury is my responsibility.",
          " running race has the physical potential to cause me injury or death during the race. If I know of any medical conditions that could interfere with me during the race, I will withdraw to prevent the danger of injury or other medical conditions.",
          " with careful consideration and of my own free will.",
          "I agree to comply with all rules and regulations set by the organizing committee.",
          "I give permission to the committee to use my photos and videos during the event for promotional purposes.",
        ],
        pdfParagraphs: [
          `I hereby declare that I voluntarily and consciously register${
            isGroupRegistration ? " and my team" : ""
          } as participants in the Jakarta Open TrailRun (JOTR) 2026 - KEJURDA I organized by ALTI DKI Jakarta, which will be held on September 26-27, 2026 in the Mount Gede Pangrango National Park area.`,
          "I understand that this activity is a trail run that is physically and mentally challenging, and has potential risks, such as extreme weather conditions, heavy terrain contours, and other health disturbances. Therefore, I declare that I have prepared myself optimally to participate in this race and am in good health.",
          `I also realize that the organizing committee, volunteers, sponsors, or other related parties are not legally responsible for risks of injury, accidents, loss, or other emergency events that ${
            isGroupRegistration ? "I or my team members" : "I"
          } may experience during the activities. All responsibility for personal safety and health during activities is ${
            isGroupRegistration ? "mine and my team members'" : "my own responsibility"
          }, and I release the committee from all forms of legal claims for events that may arise during or as a result of ${
            isGroupRegistration ? "my and my team's" : "my"
          } participation in this activity.`,
          "I am committed to:",
          [
            "Follow all rules and directions from the committee and authorities.",
            "Maintain sportsmanship, security, and order during the activities.",
            "Not take actions that harm myself, other participants, the committee, or the surrounding environment.",
          ],
          `I also give full permission to the committee to use documentation (photos, videos, or others) that contain the identity or image of ${
            isGroupRegistration ? "me and my team members" : "me"
          } for publication, promotion, and activity documentation purposes without requiring additional permission.`,
          `I hereby declare that I have read, understood, and agreed to all the contents of this statement consciously, voluntarily, and without pressure from any party. I made this statement as a form of commitment and responsibility of ${
            isGroupRegistration ? "mine and my team" : "mine"
          } as participants in JOTR 2026.`,
        ],
      }
    : {
        title: "SURAT PERNYATAAN & WAIVER",
        checkboxLabel:
          "Saya telah membaca dan menyetujui Pernyataan & Pelepasan Tanggung Jawab",
        pdfTitle: "SURAT PERNYATAAN",
        pdfNameLabel: "Nama",
        pdfTeamLabel: "Nama Tim",
        pdfDateLabel: "Tanggal",
        pdfClosing: "Hormat saya,",
        pdfPageLabel: (page, total) => `Halaman ${page} dari ${total}`,
        fileNamePrefix: "Surat_Pernyataan",
        uiParagraphs: [
          "Saya menyatakan telah membaca dan menyetujui keseluruhan pernyataan dalam dokumen ini, maka secara sadar Saya bertanggung jawab atas segala resiko yang terjadi selama dan setelah perlombaan berlangsung.",
          "Sehubungan dengan kepesertaan Saya di ",
          ", Saya secara sadar menyetujui pelepasan tanggung jawab atas segala resiko yang terjadi.",
        ],
        uiList: [
          "Saya telah membaca dan menyetujui segala informasi terkait acara, peraturan serta informasi lainnya yang berkaitan dengan ",
          "Saya menyatakan dalam keadaan sehat secara fisik untuk mengikuti lomba ",
          "Saya menyatakan, segala bentuk cedera, penyakit atau cacat fisik yang terjadi sebelum dan/atau sesudah lomba berlangsung, dimana Saya mengakui cedera tersebut menjadi tanggung jawab Saya.",
          " berpotensi secara fisik menyebabkan saya cedera atau meninggal dunia selama lomba berlangsung. Jika Saya mengetahui adanya gangguan medis yang dapat mengganggu Saya saat lomba, maka Saya akan mengundurkan diri untuk mencegah bahaya cedera atau kondisi medis lainnya.",
          " dengan pertimbangan matang dan atas kemauan sendiri.",
          "Saya setuju untuk mematuhi semua peraturan dan regulasi yang ditetapkan oleh panitia penyelenggara.",
          "Saya memberikan izin kepada panitia untuk menggunakan foto dan video Saya selama acara untuk keperluan promosi.",
        ],
        pdfParagraphs: [
          `Dengan ini menyatakan bahwa saya secara sukarela dan sadar mendaftarkan diri${
            isGroupRegistration ? " dan tim saya" : ""
          } sebagai peserta dalam kegiatan Jakarta Open TrailRun (JOTR) 2026 - KEJURDA I yang diselenggarakan oleh ALTI DKI Jakarta, yang akan dilaksanakan pada tanggal 26-27 September 2026 di kawasan Taman Nasional Gunung Gede Pangrango.`,
          "Saya memahami bahwa kegiatan ini bersifat trail run yang menantang secara fisik dan mental, serta memiliki potensi risiko, seperti kondisi cuaca ekstrem, kontur medan yang berat, dan gangguan kesehatan lainnya. Oleh karena itu, saya menyatakan bahwa saya telah mempersiapkan diri secara optimal untuk mengikuti lomba ini dan dalam kondisi kesehatan yang baik.",
          `Saya juga menyadari bahwa panitia penyelenggara, relawan, sponsor, maupun pihak-pihak terkait lainnya tidak bertanggung jawab secara hukum atas risiko cedera, kecelakaan, kehilangan, atau kejadian darurat lainnya yang mungkin ${
            isGroupRegistration ? "saya atau anggota tim saya" : "saya"
          } alami selama mengikuti rangkaian kegiatan. Seluruh tanggung jawab atas keselamatan dan kesehatan pribadi selama kegiatan merupakan tanggung jawab ${
            isGroupRegistration ? "saya dan anggota tim saya" : "saya sendiri"
          }, dan saya melepaskan panitia dari segala bentuk tuntutan hukum atas kejadian yang mungkin timbul selama atau akibat keikutsertaan ${
            isGroupRegistration ? "saya dan tim saya" : "saya"
          } dalam kegiatan ini.`,
          "Saya berkomitmen untuk:",
          [
            "Mengikuti seluruh peraturan dan arahan dari panitia dan pihak berwenang.",
            "Menjaga sportivitas, keamanan, dan ketertiban selama kegiatan berlangsung.",
            "Tidak melakukan tindakan yang merugikan diri sendiri, peserta lain, panitia, maupun lingkungan sekitar.",
          ],
          `Saya juga memberikan izin penuh kepada panitia untuk menggunakan dokumentasi (foto, video, atau lainnya) yang memuat identitas atau citra ${
            isGroupRegistration ? "saya dan anggota tim saya" : "saya"
          } untuk keperluan publikasi, promosi, dan dokumentasi kegiatan tanpa memerlukan izin tambahan.`,
          `Dengan ini, saya menyatakan telah membaca, memahami, dan menyetujui seluruh isi pernyataan ini dengan sadar, sukarela, dan tanpa tekanan dari pihak mana pun. Pernyataan ini saya buat sebagai bentuk komitmen dan tanggung jawab ${
            isGroupRegistration ? "saya dan tim saya" : "saya"
          } sebagai peserta dalam JOTR 2026.`,
        ],
      };

  const checkStep1Validity = () => {
    // 1. Common mandatory fields for the primary registrant
    const baseFields = [
      "namaLengkap",
      "email",
      "telepon",
      "nomorIdentitas",
      "tanggalLahir",
      "gender",
      "negara",
      "alamat",
      "kontakDarurat",
      "namaKontakDarurat",
      "hubunganKontakDarurat",
    ];
    if (formData.negara === "Indonesia") {
      baseFields.push("provinsi", "kota");
    }

    const missingBaseField = baseFields.find((field) => !formData[field]);
    if (missingBaseField) return false;

    // 2. Race-specific fields for the primary registrant (Individual or first participant of group)
    if (isRaceEvent) {
      const requiredJotrFields = isRoadToJOTR
        ? ["bibName", "golonganDarah", "sizeJersey"]
        : isFunRun5K
        ? ["bibName", "golonganDarah", "sizeJersey"]
        : ["bibName", "golonganDarah", "sizeJersey", "raceResultLink"];

      const missingJotrField = requiredJotrFields.find(
        (field) => !formData[field]
      );

      if (missingJotrField) return false;
    }

    // 3. Group specific validation
    if (isGroupRegistration) {
      if (!formData.teamName) return false;
      if (!formData.participants || formData.participants.length !== 3)
        return false;

      // Ensure all participants have basic data
      // For groups, specific step-by-step validation is inside InputFieldRace
      // but we need to ensure the final "Proceed" button logic aligns
      const requiredFieldsParticipants = [
        "namaDepan",
        "namaBelakang",
        "bibName",
        "telepon",
        "nomorIdentitas",
        "tanggalLahir",
        "golonganDarah",
        "sizeJersey",
        "gender",
        "negara",
        "alamat",
        "kontakDarurat",
        "namaKontakDarurat",
        "hubunganKontakDarurat",
        "raceResultLink",
      ];

      const isAnyParticipantInvalid = formData.participants.some(
        (participant) =>
          [
            ...requiredFieldsParticipants,
            ...(participant.negara === "Indonesia" ? ["provinsi", "kota"] : []),
          ].some((field) => !participant[field])
      );

      if (isAnyParticipantInvalid) return false;

      // Group gender rule: at least one female
      const allMale = formData.participants.every(
        (p) => p.gender === "Male" || p.gender === "Laki-laki"
      );
      if (allMale) return false;
    }

    return true;
  };

  // Update finalPrice berdasarkan negara (peserta utama atau anggota tim)
  useEffect(() => {
    if (price && foreignerPrice) {
      let basePrice;
      if (isGroupRegistration) {
        const hasForeignParticipant =
          formData.negara !== "Indonesia" ||
          formData.participants.some(
            (participant) => participant.negara !== "Indonesia"
          );
        basePrice = hasForeignParticipant ? foreignerPrice : price;
      } else {
        basePrice = formData.negara === "Indonesia" ? price : foreignerPrice;
      }
      const newFinalPrice = Math.floor(basePrice * (1 - discount / 100));
      setFinalPrice(newFinalPrice);
    }
  }, [
    formData.negara,
    formData.participants,
    price,
    foreignerPrice,
    discount,
    isGroupRegistration,
  ]);

  const humanize = (str) => {
    if (!str) return "";
    if (str === "nomorIdentitas") return "Identity Number";
    if (str === "namaDepan") return "First Name";
    if (str === "namaBelakang") return "Last Name";
    if (str === "namaLengkap") return "Full Name";
    if (str === "tanggalLahir") return "Date of Birth";
    if (str === "golonganDarah") return "Blood Type";
    if (str === "sizeJersey") return "Jersey Size";
    if (str === "kontakDarurat") return "Emergency Contact Number";
    if (str === "namaKontakDarurat") return "Emergency Contact Name";
    if (str === "hubunganKontakDarurat") return "Emergency Contact Relation";
    if (str === "raceResultLink") return "STRAVA or Race Result Link";
    if (str === "teamName") return "Team Name";
    
    const withSpaces = str.replace(/([A-Z])/g, " $1").trim();
    return withSpaces
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const fetchCollectionName = async (eventId) => {
    try {
      // 1. Get Configuration (Collection Name) from 'events'
      // This is the source of truth for "dynamic mapping" per user instruction
      const configRef = doc(db, "events", eventId);
      const configDoc = await getDoc(configRef);
      // 2. Get Event Content (Title, Price, Categories) from 'semuaKegiatan'
      // This refers to the actual event display data
      const contentRef = doc(db, "semuaKegiatan", eventId);
      const contentDoc = await getDoc(contentRef);
      const validCollectionName =
        initialCollectionName ||
        (configDoc.exists() ? configDoc.data().collectionName : null) ||
        (contentDoc.exists() ? contentDoc.data().collectionName : null) ||
        `pendaftaran${eventId}`;
      setCollectionName(validCollectionName);
      
      if (contentDoc.exists()) {
          return contentDoc.data();
      }
      
      throw new Error("Event document not found.");
    } catch (error) {
      setErrorMsg("Failed to fetch event data. Please try again.");
      showNotification(
        "error",
        "Failed to fetch event data. Please try again.",
        "Close"
      );
      return null;
    }
  };

  const fetchCategoryDetails = async (eventId, title) => {
    try {
      const eventRef = doc(db, "semuaKegiatan", eventId);
      const eventDoc = await getDoc(eventRef);
      if (eventDoc.exists()) {
        const eventData = eventDoc.data();
        if (eventData.type === "seminar") {
          setCategoryName(eventData.title);
          setDistance(0);
        } else {
          const categories = eventData.categories || [];
          let selectedCategory = categories.find((cat) =>
            title.includes(cat.categoryName)
          );
          if (!selectedCategory && categories.length > 0) {
            selectedCategory = categories.find(
              (cat) => cat.categoryName === "Vertical 7K"
            );
          }
          if (selectedCategory) {
            setCategoryName(selectedCategory.categoryName);
            setDistance(selectedCategory.distance);
          } else {
            throw new Error("Category not found in event data.");
          }
        }
      } else {
        throw new Error("Event document not found.");
      }
    } catch (error) {
      const msg = "Category or distance data is incomplete.";
      showNotification("error", msg, "Close");
    }
  };

  const checkRegistration = async (collectionName) => {
    if (!user || !eventId || !collectionName) return;

    try {
      const inactiveStatuses = ["expire", "cancel", "deny", "failure"];
      const q = query(
        collection(db, collectionName),
        where("uid", "==", user.uid),
        where("eventId", "==", eventId),
        limit(5)
      );
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const activeDoc = querySnapshot.docs
          .map((d) => ({ ref: d.ref, ...d.data() }))
          .find((data) => {
            const status = data.transaction_status || "unknown";
            const adminStatus = data.administration_status || "";
            if (adminStatus === "rejected") return false;
            if (inactiveStatuses.includes(status)) return false;
            return (
              status === "settlement" ||
              status === "pending" ||
              adminStatus === "pending" ||
              adminStatus === "qualified"
            );
          });

        if (!activeDoc) {
          setRegistrationStatus("not_registered");
          return;
        }

        const status = activeDoc.transaction_status || "unknown";
        const adminStatus = activeDoc.administration_status || "";

        setRegistrationStatus("registered");
        setTransactionStatus(status === "settlement" ? "settlement" : status === "pending" ? "pending" : adminStatus);
        setSnapToken(activeDoc.snapToken || null);
        setOrderId(activeDoc.orderId || activeDoc.id || null);
        setVoucherCode(activeDoc.voucherCode || null);
        setFormData((prev) => ({
          ...prev,
          teamName: isGroupRegistration ? activeDoc.teamName || prev.teamName : "",
        }));
      } else {
        setRegistrationStatus("not_registered");
      }
    } catch (err) {
      console.error("[FormPendaftaran] Failed to check registration:", err);
      setRegistrationStatus("not_registered");
    }
  };

  const loadDraftData = async () => {
    if (!user || !eventId || !isGroupRegistration || isDraftLoaded) return;

    try {
      const draftDocRef = doc(db, "registrations", `${user.uid}_${eventId}`);
      const draftDoc = await getDoc(draftDocRef);
      if (draftDoc.exists()) {
        const draftData = draftDoc.data();
        if (draftData.status === "draft") {
          const updatedParticipants = draftData.participants.map(
            (participant, index) => ({
              namaDepan: participant.namaDepan || "",
              namaBelakang: participant.namaBelakang || "",
              bibName: participant.bibName || "",
              telepon: participant.telepon || "",
              nomorIdentitas: participant.nomorIdentitas || "",
              tanggalLahir: participant.tanggalLahir || "",
              golonganDarah: participant.golonganDarah || "",
              sizeJersey: participant.sizeJersey || "",
              gender: normalizeGender(participant.gender || ""),
              negara: participant.negara || "Indonesia",
              provinsi: participant.provinsi || "",
              kota: participant.kota || "",
              alamat: participant.alamat || "",
              kontakDarurat: participant.kontakDarurat || "",
              namaKontakDarurat: participant.namaKontakDarurat || "",
              hubunganKontakDarurat: participant.hubunganKontakDarurat || "",
              performanceIndex: participant.performanceIndex || "",
              raceResultLink: participant.raceResultLink || "",
            })
          );
          setFormData((prev) => {
            const firstParticipant = updatedParticipants[0] || {};
            const newFormData = {
              ...prev,
              teamName: draftData.teamName || "",
              participants: updatedParticipants,
              namaDepan: firstParticipant.namaDepan || prev.namaDepan,
              namaBelakang: firstParticipant.namaBelakang || prev.namaBelakang,
              namaLengkap:
                firstParticipant.namaDepan && firstParticipant.namaBelakang
                  ? `${firstParticipant.namaDepan} ${firstParticipant.namaBelakang}`.trim()
                  : prev.namaLengkap,
              telepon: firstParticipant.telepon || prev.telepon,
              nomorIdentitas:
                firstParticipant.nomorIdentitas || prev.nomorIdentitas,
              tanggalLahir: firstParticipant.tanggalLahir || prev.tanggalLahir,
              gender: normalizeGender(firstParticipant.gender || prev.gender),
              negara: firstParticipant.negara || prev.negara,
              provinsi: firstParticipant.provinsi || prev.provinsi,
              kota: firstParticipant.kota || prev.kota,
              alamat: firstParticipant.alamat || prev.alamat,
              kontakDarurat:
                firstParticipant.kontakDarurat || prev.kontakDarurat,
              namaKontakDarurat:
                firstParticipant.namaKontakDarurat || prev.namaKontakDarurat,
              hubunganKontakDarurat:
                firstParticipant.hubunganKontakDarurat ||
                prev.hubunganKontakDarurat,
              bibName: firstParticipant.bibName || prev.bibName,
              golonganDarah:
                firstParticipant.golonganDarah || prev.golonganDarah,
              sizeJersey: firstParticipant.sizeJersey || prev.sizeJersey,
              performanceIndex:
                firstParticipant.performanceIndex || prev.performanceIndex,
              raceResultLink:
                firstParticipant.raceResultLink || prev.raceResultLink,
            };
            return newFormData;
          });
          showNotification(
            "success",
            "Previous draft data has been loaded. Please continue or submit.",
            "Close"
          );
          setIsDraftLoaded(true);
        }
      } else {
        setIsDraftLoaded(true);
      }
    } catch (err) {
      setErrorMsg("Failed to load draft data. Please try again.");
      showNotification(
        "error", 
        "Failed to load draft data. Please try again.",
        "Close"
      );
      setIsDraftLoaded(true);
    }
  };

  useEffect(() => {
    if (!eventId || !title || !price || !foreignerPrice) {
      showNotification(
        "error",
        "Please select a category from the events page.",
        "Close"
      );
      navigate("/");
      return;
    }

    if (!Number.isInteger(price) || !Number.isInteger(foreignerPrice)) {
      const msg = "Invalid event price.";
      showNotification("error", msg, "Close");
      navigate("/");
      return;
    }

    const initialize = async () => {
      if (isInitialized) return;
      
      if (!user) {
        navigate("/login");
        showNotification(
            "error", 
            "Please login to register.",
            "Close"
        );
        return;
      }

      try {
        const eventData = await fetchCollectionName(eventId);
        if (!eventData) {
          navigate("/");
          return;
        }
        await fetchCategoryDetails(eventId, title);

        if (isGroupRegistration && !isDraftLoaded) {
          await loadDraftData();
        }

        if (!isDraftLoaded || !isGroupRegistration) {
          const docRef = doc(db, "users", user.uid);
          const docSnap = await getDoc(docRef);
          let userData = {};

          if (docSnap.exists()) {
            userData = docSnap.data();
            let namaDepan = userData.namaDepan || "";
            let namaBelakang = userData.namaBelakang || "";
            let namaLengkap = userData.namaLengkap || "";

            if (!namaDepan && !namaBelakang && namaLengkap) {
              const namaSplit = namaLengkap.trim().split(/\s+/);
              namaDepan = namaSplit[0] || "";
              namaBelakang = namaSplit.slice(1).join(" ") || "";
            }

            let participants = formData.participants;
            let rootFields = {};
            if (isGroupRegistration) {
              participants = [
                {
                  namaDepan,
                  namaBelakang,
                  bibName: userData.bibName || "",
                  telepon: userData.telepon || "",
                  nomorIdentitas: userData.nomorIdentitas || "",
                  tanggalLahir: userData.tanggalLahir || "",
                  golonganDarah: userData.golonganDarah || "",
                  sizeJersey: userData.sizeJersey || "",
                  gender: normalizeGender(userData.gender || ""),
                  negara: userData.negara || "Indonesia",
                  provinsi: userData.provinsi || "",
                  kota: userData.kota || "",
                  alamat: userData.alamat || "",
                  kontakDarurat: userData.kontakDarurat || "",
                  namaKontakDarurat: userData.namaKontakDarurat || "",
                  hubunganKontakDarurat: userData.hubunganKontakDarurat || "",
                  performanceIndex: userData.performanceIndex || "",
                  raceResultLink: userData.raceResultLink || "",
                },
                {
                  namaDepan: "",
                  namaBelakang: "",
                  bibName: "",
                  telepon: "",
                  nomorIdentitas: "",
                  tanggalLahir: "",
                  golonganDarah: "",
                  sizeJersey: "",
                  gender: "",
                  negara: "Indonesia",
                  provinsi: "",
                  kota: "",
                  alamat: "",
                  kontakDarurat: "",
                  namaKontakDarurat: "",
                  hubunganKontakDarurat: "",
                  performanceIndex: "",
                  raceResultLink: "",
                },
                {
                  namaDepan: "",
                  namaBelakang: "",
                  bibName: "",
                  telepon: "",
                  nomorIdentitas: "",
                  tanggalLahir: "",
                  golonganDarah: "",
                  sizeJersey: "",
                  gender: "",
                  negara: "Indonesia",
                  provinsi: "",
                  kota: "",
                  alamat: "",
                  kontakDarurat: "",
                  namaKontakDarurat: "",
                  hubunganKontakDarurat: "",
                  performanceIndex: "",
                  raceResultLink: "",
                },
              ];
              rootFields = {
                namaDepan,
                namaBelakang,
                namaLengkap:
                  namaLengkap || `${namaDepan} ${namaBelakang}`.trim(),
                email: userData.email || user.email || "",
                telepon: userData.telepon || "",
                nomorIdentitas: userData.nomorIdentitas || "",
                tanggalLahir: userData.tanggalLahir || "",
                gender: normalizeGender(userData.gender || ""),
                negara: userData.negara || "Indonesia",
                provinsi: userData.provinsi || "",
                kota: userData.kota || "",
                alamat: userData.alamat || "",
                kontakDarurat: userData.kontakDarurat || "",
                namaKontakDarurat: userData.namaKontakDarurat || "",
                hubunganKontakDarurat: userData.hubunganKontakDarurat || "",
                bibName: isRaceEvent ? userData.bibName || "" : "",
                golonganDarah:
                  isRaceEvent ? userData.golonganDarah || "" : "",
                sizeJersey: isRaceEvent ? userData.sizeJersey || "" : "",
                performanceIndex:
                  isRaceEvent ? userData.performanceIndex || "" : "",
                raceResultLink:
                  isJotrMainEvent ? userData.raceResultLink || "" : "",
                certificateUrl:
                  isJotrMainEvent ? userData.certificateUrl || "" : "",
                riwayatMedis:
                  isRaceEvent ? userData.riwayatMedis || "" : "",
              };
            } else {
              rootFields = {
                namaDepan,
                namaBelakang,
                namaLengkap:
                  namaLengkap || `${namaDepan} ${namaBelakang}`.trim(),
                email: userData.email || user.email || "",
                telepon: userData.telepon || "",
                nomorIdentitas: userData.nomorIdentitas || "",
                tanggalLahir: userData.tanggalLahir || "",
                gender: normalizeGender(userData.gender || ""),
                negara: userData.negara || "Indonesia",
                provinsi: userData.provinsi || "",
                kota: userData.kota || "",
                alamat: userData.alamat || "",
                kontakDarurat: userData.kontakDarurat || "",
                namaKontakDarurat: userData.namaKontakDarurat || "",
                hubunganKontakDarurat: userData.hubunganKontakDarurat || "",
                bibName:
                  isRaceEvent && !isGroupRegistration
                    ? userData.bibName || ""
                    : "",
                golonganDarah:
                  isRaceEvent && !isGroupRegistration
                    ? userData.golonganDarah || ""
                    : "",
                sizeJersey:
                  isRaceEvent && !isGroupRegistration
                    ? userData.sizeJersey || ""
                    : "",
                performanceIndex:
                  isRaceEvent && !isGroupRegistration
                    ? userData.performanceIndex || ""
                    : "",
                raceResultLink:
                  isJotrMainEvent ? userData.raceResultLink || "" : "",
                certificateUrl:
                  isJotrMainEvent ? userData.certificateUrl || "" : "",
                riwayatMedis:
                  isRaceEvent ? userData.riwayatMedis || "" : "",
              };
            }

            setFormData((prev) => {
              const newFormData = {
                ...prev,
                ...rootFields,
                teamName: isGroupRegistration ? prev.teamName : "",
                participants: isGroupRegistration
                  ? participants
                  : prev.participants,
              };
              return newFormData;
            });
          } else {
            const namaSplit = (user.displayName || "").trim().split(/\s+/);
            const namaDepan = namaSplit[0] || "";
            const namaBelakang = namaSplit.slice(1).join(" ") || "";
            setFormData((prev) => {
              const newFormData = {
                ...prev,
                namaDepan,
                namaBelakang,
                namaLengkap:
                  namaDepan && namaBelakang
                    ? `${namaDepan} ${namaBelakang}`.trim()
                    : "",
                email: user.email || "",
              };
              return newFormData;
            });
          }
        }


        
        setIsInitialized(true);

        // checkRegistration sekarang ditangani oleh useEffect terpisah
        // untuk mencegah race condition dan error permission
      } catch (err) {
        setErrorMsg("Failed to fetch user data.");
        showNotification(
            "error", 
            "Failed to fetch user data.",
            "Close"
        );
        return;
      }
    };



    const checkSnap = setInterval(() => {
      if (window.snap) {
        setIsSnapReady(true);
        clearInterval(checkSnap);
      }
    }, 100);

    // Initial Data Fetching
    if (eventId && title && price && user) {
      initialize();
    } else {
      if (!categoryName) {
        setErrorMsg("Please select a category from the events page.");
        return;
      }
      navigate("/");
    }

    return () => clearInterval(checkSnap);
  }, [
    eventId,
    title,
    price,
    foreignerPrice,
    navigate,
    showNotification,
    user,
    // Removed collectionName and categoryName from here to prevent re-running initialize loop
  ]);

  // Separate Effect for Checking Registration
  useEffect(() => {
    // Only run if we have all necessary pieces of information
    if (user && eventId && collectionName && categoryName && !registrationStatus) {
      console.log("[FormPendaftaran] Checking registration for:", {
        collection: collectionName,
        category: categoryName
      });
      checkRegistration(collectionName);
    }
  }, [user, eventId, collectionName, categoryName, registrationStatus]);

  const handleChange = (e, participantIndex = null) => {
    if (participantIndex !== null) {
      const { name, value } = e.target;
      setFormData((prev) => {
        const updatedParticipants = [...prev.participants];
        updatedParticipants[participantIndex] = {
          ...updatedParticipants[participantIndex],
          [name]: value,
        };
        const updatedFormData = { ...prev, participants: updatedParticipants };
        if (participantIndex === 0 && name === "negara") {
          updatedFormData.negara = value;
        }
        return updatedFormData;
      });
    } else {
      const { name, value } = e.target;
      setFormData((prev) => {
        const updated = { ...prev, [name]: value };
        if (name === "namaDepan" || name === "namaBelakang") {
          updated.namaLengkap = `${updated.namaDepan || ""} ${
            updated.namaBelakang || ""
          }`.trim();
        }
        if (name === "namaLengkap") {
          const namaSplit = value.trim().split(/\s+/);
          updated.namaDepan = namaSplit[0] || "";
          updated.namaBelakang = namaSplit.slice(1).join(" ") || "";
        }
        if (isGroupRegistration && name === "negara") {
          const updatedParticipants = [...updated.participants];
          updatedParticipants[0] = {
            ...updatedParticipants[0],
            negara: value,
          };
          updated.participants = updatedParticipants;
        }
        return updated;
      });
    }
  };

  const handleApplyVoucher = (code, discountPercentage) => {
    setVoucherCode(code);
    setDiscount(discountPercentage);
    let basePrice;
    if (isGroupRegistration) {
      const hasForeignParticipant =
        formData.negara !== "Indonesia" ||
        formData.participants.some(
          (participant) => participant.negara !== "Indonesia"
        );
      basePrice = hasForeignParticipant ? foreignerPrice : price;
    } else {
      basePrice = formData.negara === "Indonesia" ? price : foreignerPrice;
    }
    const newFinalPrice = Math.floor(
      basePrice * (1 - discountPercentage / 100)
    );
    setFinalPrice(newFinalPrice);
  };

  const updateUserData = async (updatedFields) => {
    try {
      const docRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(docRef);
      const existingData = docSnap.exists() ? docSnap.data() : {};

      const fieldsToUpdate = {};
      Object.keys(updatedFields).forEach((key) => {
        if (
          key !== "participants" &&
          key !== "teamName" &&
          updatedFields[key] !== undefined &&
          updatedFields[key] !== ""
        ) {
          fieldsToUpdate[key] = updatedFields[key];
        } else if (!existingData[key]) {
          fieldsToUpdate[key] = "";
        }
      });
      fieldsToUpdate.updatedAt = serverTimestamp();

      await updateDoc(docRef, fieldsToUpdate);
    } catch (err) {
      setErrorMsg("Failed to update user data.");
      showNotification(
          "error", 
          "Failed to update user data.",
          "Close"
      );
    }
  };

  const simpanSuratPernyataanSebagaiPDF = async () => {
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    const marginLeft = 20;
    const marginTop = 20;
    const lineHeight = 7;
    const bulletIndent = 5;
    let yPosition = marginTop;

    // Header
    pdf.setFontSize(16);
    pdf.setFont("helvetica", "bold");
    pdf.text(waiverContent.pdfTitle, 105, yPosition, { align: "center" });
    yPosition += lineHeight * 2;

    pdf.setFontSize(12);
    pdf.setFont("helvetica", "normal");

    // Informasi peserta
    const namaLengkap = formData.namaLengkap || "Unknown";
    const today = new Date();
    const tanggal = today.toLocaleDateString(isForeigner ? "en-US" : "id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

    pdf.text(`${waiverContent.pdfNameLabel}: ${namaLengkap}`, marginLeft, yPosition);
    yPosition += lineHeight;
    if (isGroupRegistration) {
      pdf.text(
        `${waiverContent.pdfTeamLabel}: ${formData.teamName || "Unknown"}`,
        marginLeft,
        yPosition
      );
      yPosition += lineHeight;
    }
    pdf.text(`${waiverContent.pdfDateLabel}: ${tanggal}`, marginLeft, yPosition);
    yPosition += lineHeight * 2;

    const paragraphs = waiverContent.pdfParagraphs;

    paragraphs.forEach((item) => {
      if (Array.isArray(item)) {
        item.forEach((bullet) => {
          const lines = pdf.splitTextToSize(bullet, 170 - bulletIndent);
          lines.forEach((line, index) => {
            if (yPosition + lineHeight > 277) {
              pdf.addPage();
              yPosition = marginTop;
            }
            const text = index === 0 ? `• ${line}` : line;
            const xOffset =
              index === 0 ? marginLeft : marginLeft + bulletIndent;
            pdf.text(text, xOffset, yPosition);
            yPosition += lineHeight;
          });
        });
      } else {
        const lines = pdf.splitTextToSize(item, 170);
        lines.forEach((line) => {
          if (yPosition + lineHeight > 277) {
            pdf.addPage();
            yPosition = marginTop;
          }
          pdf.text(line, marginLeft, yPosition);
          yPosition += lineHeight;
        });
      }
      yPosition += lineHeight;
    });

    if (yPosition + lineHeight * 3 > 277) {
      pdf.addPage();
      yPosition = marginTop;
    }
    pdf.text(waiverContent.pdfClosing, 170, yPosition, { align: "right" });
    yPosition += lineHeight * 2;
    pdf.setFont("helvetica", "bold");
    pdf.text(namaLengkap, 170, yPosition, { align: "right" });

    const pageCount = pdf.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      pdf.setPage(i);
      pdf.setFontSize(10);
      pdf.text(waiverContent.pdfPageLabel(i, pageCount), 105, 287, {
        align: "center",
      });
    }

    const pdfBlob = pdf.output("blob");
    const fileName = `${waiverContent.fileNamePrefix}_${namaLengkap.replace(/\s+/g, "_")}_${eventId}${isGroupRegistration ? `_${formData.teamName.replace(/\s+/g, "_")}` : ""}.pdf`;

    try {
      console.log(`[FormPendaftaran] Uploading statement letter for user ${user.uid}...`);
      const suratQuery = query(
        collection(db, "suratPernyataan"),
        where("userId", "==", user.uid),
        where("eventId", "==", eventId),
        limit(1)
      );
      const suratSnapshot = await getDocs(suratQuery);
      if (!suratSnapshot.empty) {
        console.log(
          `[FormPendaftaran] Statement letter for user ${user.uid} already exists, skipping...`
        );
        return;
      }

      const storageRef = ref(
        storage,
        `suratPernyataan/${user.uid}/${fileName}`
      );
      await uploadBytes(storageRef, pdfBlob);
      const downloadURL = await getDownloadURL(storageRef);
      console.log(
        `[FormPendaftaran] File ${fileName} successfully uploaded for user ${user.uid}`
      );

      const docData = {
        namaLengkap,
        tanggal,
        fileName,
        downloadURL,
        createdAt: serverTimestamp(),
        userId: user.uid,
        eventId,
      };
      if (isGroupRegistration) {
        docData.teamName = formData.teamName || "Unknown";
      }

      await addDoc(collection(db, "suratPernyataan"), docData);
      console.log(
        `[FormPendaftaran] Statement letter metadata saved for user ${user.uid}`
      );
    } catch (err) {
      console.error(
        `[FormPendaftaran] Failed to save statement letter for user ${user.uid}:`,
        err.message
      );
      setErrorMsg("Failed to save waiver document.");
      showNotification(
          "error", 
          "Failed to save waiver document.",
          "Close"
      );
      throw err;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Prevent double submission to avoid duplicate Order IDs
    if (loading) return;
    
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");

    if (!isSnapReady) {
      setErrorMsg("Preparing payment system, please wait...");
      showNotification(
        "error",
        "Preparing payment system, please wait...",
        "Close"
      );
      setLoading(false);
      return;
    }

    if (!isRoadToJOTR && !isChecked) {
      const msg = "Please agree to the Waiver before continuing.";
      setErrorMsg(msg);
      showNotification(
        "error",
        msg,
        "Close"
      );
      setLoading(false);
      return;
    }

    if (!categoryName || (eventId !== "PelatihanPelatih" && !distance)) {
      const msg = "Category or distance data is incomplete.";
      setErrorMsg(msg);
      showNotification("error", msg, "Close");
      setLoading(false);
      return;
    }

    const normalizeGender = (value) => {
      if (!value) return "";
      const lower = value.toLowerCase().trim();
      if (lower === "laki-laki" || lower === "pria" || lower === "male") return "Male";
      if (lower === "perempuan" || lower === "wanita" || lower === "female") return "Female";
      return value;
    };

    const validateFormat = (
      field,
      value,
      participantIndex = null,
      negara = "Indonesia"
    ) => {
      const prefix =
        participantIndex !== null ? `Participant ${participantIndex + 1}: ` : "";
      const label = humanize(field);

      if (!value || value.trim() === "") {
        return `${prefix}${label} is required`;
      }
      if (field === "teamName" && !/^[A-Za-z0-9\s]{3,50}$/.test(value)) {
        return `${prefix}${label} must be 3-50 characters, alphanumeric with spaces.`;
      }
      if (
        (field === "namaDepan" || field === "namaBelakang") &&
        !/^[A-Za-z\s]{1,50}$/.test(value)
      ) {
        return `${prefix}${label} only allows letters and spaces, maximum 50 characters.`;
      }
      if (field === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return `${prefix}${label} must be a valid format (example: user@example.com).`;
      }
      if (field === "bibName" && !/^[A-Za-z0-9\s]{1,20}$/.test(value)) {
        return `${prefix}${label} must be 1-20 characters alphanumeric and spaces.`;
      }
      if (
        (field === "telepon" || field === "kontakDarurat") &&
        !/^\+?\d{8,15}$/.test(value)
      ) {
        return `${prefix}${label} must be 8-15 digits, can start with "+".`;
      }
      if (field === "nomorIdentitas") {
        if (negara === "Indonesia") {
          if (!/^\d{16}$/.test(value)) {
            return `${prefix}${label} (KTP) must be 16 digits for Indonesian participants.`;
          }
        } else {
          if (!/^[A-Za-z0-9]{5,20}$/.test(value)) {
            return `${prefix}${label} (Passport/Identity) must be 5-20 alphanumeric characters for foreigners.`;
          }
        }
      }
      if (field === "tanggalLahir") {
        const date = new Date(value);
        const eventDate = new Date("2026-07-24");
        const minAgeDate = new Date(
          eventDate.getFullYear() - 17,
          eventDate.getMonth(),
          eventDate.getDate()
        );
        if (isNaN(date.getTime()) || date >= eventDate) {
          return `${prefix}${label} must be in the past before 24/07/2026`;
        } else if (date > minAgeDate) {
          return `${prefix}Participants must be at least 17 years old on 24/07/2026`;
        }
      }
      if (field === "golonganDarah" && !["A", "B", "AB", "O"].includes(value)) {
        return `${prefix}${label} must be A, B, AB, or O.`;
      }
      if (
        field === "sizeJersey" &&
        !["XS", "S", "M", "L", "XL", "XXL"].includes(value)
      ) {
        return `${prefix}${label} must be XS, S, M, L, XL, or XXL.`;
      }
      if (
        field === "gender" &&
        !["Male", "Female", "Laki-laki", "Perempuan", "Pria", "Wanita"].includes(value)
      ) {
        return `${prefix}${label} must be Male or Female.`;
      }
      if (field === "alamat" && !/^[A-Za-z0-9\s,.-/#()]{5,100}$/.test(value)) {
        return `${prefix}${label} must be 5-100 characters, can be letters, numbers, spaces, and punctuation.`;
      }
      if (field === "namaKontakDarurat" && !/^[A-Za-z\s]{1,50}$/.test(value)) {
        return `${prefix}${label} only allows letters and spaces, maximum 50 characters.`;
      }
      if (
        field === "hubunganKontakDarurat" &&
        !/^[A-Za-z\s]{1,50}$/.test(value)
      ) {
        return `${prefix}${label} only allows letters and spaces, maximum 50 characters.`;
      }
      if (field === "performanceIndex" && value && !/^\d{3}$/.test(value)) {
        return `${prefix}${label} must be 3 digits, use "000" if no index`;
      }
      if (field === "raceResultLink") {
        if (!value || !value.trim()) {
          return `${prefix}${label} is required. Strava or similar application link.`;
        }
        const trimmed = value.trim();
        const normalized = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
        if (!/^https?:\/\/[^\s]+/.test(normalized)) {
          return `${prefix}${label}: Invalid link. Please ensure it starts with https://`;
        }
      }
      return "";
    };

    const requiredFields = [
      "namaDepan",
      "namaBelakang",
      "email",
      "telepon",
      "nomorIdentitas",
      "tanggalLahir",
      "gender",
      "negara",
      "alamat",
      "kontakDarurat",
      "namaKontakDarurat",
      "hubunganKontakDarurat",
      ...(eventId.startsWith("JOTR")
        ? (isRoadToJOTR
            ? ["bibName", "golonganDarah", "sizeJersey"]
            : ["bibName", "golonganDarah", "sizeJersey", "raceResultLink"])
        : []),
    ];

    const errors = {};
    for (const field of requiredFields) {
      const error = validateFormat(
        field,
        formData[field],
        null,
        formData.negara
      );
      if (error) {
        errors[field] = error;
      }
    }


    if (isGroupRegistration) {
      const teamNameError = validateFormat("teamName", formData.teamName);
      if (teamNameError) {
        errors.teamName = teamNameError;
      }
      if (formData.participants.length !== 3) {
        errors.participants = "A team must consist of exactly 3 participants.";
      } else {
        const allMale = formData.participants.every(
          (p) => p.gender === "Male" || p.gender === "Laki-laki"
        );
        if (allMale) {
          errors.gender = "The team cannot be all male. At least one female member is required.";
        }
        const requiredFieldsParticipants = [
          "namaDepan",
          "namaBelakang",
          "telepon",
          "nomorIdentitas",
          "tanggalLahir",
          "golonganDarah",
          "sizeJersey",
          "gender",
          "negara",
          "alamat",
          "kontakDarurat",
          "namaKontakDarurat",
          "hubunganKontakDarurat",
          "raceResultLink",
        ];
        const bibNames = new Set();
        for (let i = 0; i < formData.participants.length; i++) {
          const participant = formData.participants[i];
          for (const field of requiredFieldsParticipants) {
            const error = validateFormat(
              field,
              participant[field],
              i,
              participant.negara
            );
            if (error) {
              errors[`${field}_${i}`] = error;
            }
          }
          if (participant.bibName) {
            if (bibNames.has(participant.bibName)) {
              errors[`bibName_${i}`] = `BIB Name for participant ${i + 1} has already been used.`;
            } else {
              bibNames.add(participant.bibName);
            }
          }
        }
      }
    }

    if (Object.keys(errors).length > 0) {
      const firstError = Object.values(errors)[0];
      setErrorMsg(firstError);
      showNotification("error", firstError);
      setFormData((prev) => ({ ...prev, errors }));
      setLoading(false);
      return;
    }

    if (!Number.isInteger(finalPrice)) {
      const msg = "The final price must be a whole number.";
      setErrorMsg(msg);
      showNotification("error", msg, "Close");
      setLoading(false);
      return;
    }

    if (!executeRecaptcha) {
      showNotification(
        "error", 
        "Security check not ready. Please refresh.",
        "Close"
      );
      setLoading(false);
      return;
    }

    const recaptchaToken = await executeRecaptcha("registration_submit");
    if (!recaptchaToken) {
        showNotification(
            "error", 
            "Failed to verify captcha (bot detected).",
            "Close"
        );
        setLoading(false);
        return;
    }

    try {
      if (!eventId || !title || !price || !foreignerPrice) {
        throw new Error(
          "Event data is incomplete. Please try again from the category page."
        );
      }

      const sanitizeValue = (value) => {
        if (typeof value === "string") {
          const trimmed = value.trim();
          return trimmed === "" ? undefined : trimmed.replace(/\s+/g, " ");
        }
        return value;
      };

      const sanitizedFormData = {
        ...formData,
        namaDepan: sanitizeValue(formData.namaDepan),
        namaBelakang: sanitizeValue(formData.namaBelakang),
        namaLengkap: sanitizeValue(formData.namaLengkap),
        email: sanitizeValue(formData.email),
        telepon: sanitizeValue(formData.telepon),
        nomorIdentitas: formData.nomorIdentitas ? formData.nomorIdentitas.trim().replace(/\s+/g, "") : undefined,
        tanggalLahir: sanitizeValue(formData.tanggalLahir),
        gender: sanitizeValue(formData.gender),
        negara: sanitizeValue(formData.negara),
        provinsi: sanitizeValue(formData.provinsi),
        kota: sanitizeValue(formData.kota),
        alamat: sanitizeValue(formData.alamat),
        kontakDarurat: sanitizeValue(formData.kontakDarurat),
        namaKontakDarurat: sanitizeValue(formData.namaKontakDarurat),
        hubunganKontakDarurat: sanitizeValue(formData.hubunganKontakDarurat),
        bibName: isRaceEvent ? sanitizeValue(formData.bibName) : undefined,
        golonganDarah: isRaceEvent ? sanitizeValue(formData.golonganDarah) : undefined,
        sizeJersey: isRaceEvent ? sanitizeValue(formData.sizeJersey) : undefined,
        performanceIndex: isRaceEvent ? sanitizeValue(formData.performanceIndex) : undefined,
        raceResultLink: isJotrMainEvent
          ? (() => {
              const v = sanitizeValue(formData.raceResultLink);
              if (!v) return undefined;
              return /^https?:\/\//i.test(v) ? v : `https://${v}`;
            })()
          : undefined,
        certificateUrl: isJotrMainEvent ? sanitizeValue(formData.certificateUrl) : undefined,
        riwayatMedis: isRaceEvent ? sanitizeValue(formData.riwayatMedis) : undefined,
        teamName: isGroupRegistration ? sanitizeValue(formData.teamName) : undefined,
        participants: isGroupRegistration
          ? formData.participants.map((participant) => ({
              namaDepan: sanitizeValue(participant.namaDepan),
              namaBelakang: sanitizeValue(participant.namaBelakang),
              telepon: sanitizeValue(participant.telepon),
              nomorIdentitas: participant.nomorIdentitas ? participant.nomorIdentitas.trim().replace(/\s+/g, "") : undefined,
              tanggalLahir: sanitizeValue(participant.tanggalLahir),
              golonganDarah: sanitizeValue(participant.golonganDarah),
              sizeJersey: sanitizeValue(participant.sizeJersey),
              gender: sanitizeValue(participant.gender),
              negara: sanitizeValue(participant.negara),
              provinsi: sanitizeValue(participant.provinsi),
              kota: sanitizeValue(participant.kota),
              alamat: sanitizeValue(participant.alamat),
              kontakDarurat: sanitizeValue(participant.kontakDarurat),
              namaKontakDarurat: sanitizeValue(participant.namaKontakDarurat),
              hubunganKontakDarurat: sanitizeValue(
                participant.hubunganKontakDarurat
              ),
              performanceIndex: sanitizeValue(participant.performanceIndex),
              raceResultLink: (() => {
                const v = sanitizeValue(participant.raceResultLink);
                if (!v) return undefined;
                return /^https?:\/\//i.test(v) ? v : `https://${v}`;
              })(),
              bibName: sanitizeValue(participant.bibName),
            }))
          : formData.participants,
      };

      const sanitizedErrors = {};
      for (const field of requiredFields) {
        const error = validateFormat(
          field,
          sanitizedFormData[field],
          null,
          sanitizedFormData.negara
        );
        if (error) {
          sanitizedErrors[field] = error;
        }
      }
      if (isGroupRegistration) {
        const teamNameError = validateFormat(
          "teamName",
          sanitizedFormData.teamName
        );
        if (teamNameError) {
          sanitizedErrors.teamName = teamNameError;
        }
        if (sanitizedFormData.participants.length !== 3) {
          sanitizedErrors.participants = "A team must consist of exactly 3 participants.";
        } else {
          const allMale = sanitizedFormData.participants.every(
            (p) => p.gender === "Male" || p.gender === "Laki-laki"
          );
          if (allMale) {
            sanitizedErrors.gender = "The team cannot be all male. At least one female member is required.";
          }
          const requiredFieldsParticipants = [
            "namaDepan",
            "namaBelakang",
            "telepon",
            "nomorIdentitas",
            "tanggalLahir",
            "golonganDarah",
            "sizeJersey",
            "gender",
            "negara",
            "alamat",
            "kontakDarurat",
            "namaKontakDarurat",
            "hubunganKontakDarurat",
            "raceResultLink",
          ];
          const bibNames = new Set();
          for (let i = 0; i < sanitizedFormData.participants.length; i++) {
            const participant = sanitizedFormData.participants[i];
            const participantRequiredFields = [
              ...requiredFieldsParticipants,
              ...(participant.negara === "Indonesia" ? ["provinsi", "kota"] : []),
            ];
            for (const field of participantRequiredFields) {
              const error = validateFormat(
                field,
                participant[field],
                i,
                participant.negara
              );
              if (error) {
                sanitizedErrors[`${field}_${i}`] = error;
              }
            }
            if (participant.bibName) {
              if (bibNames.has(participant.bibName)) {
                sanitizedErrors[`bibName_${i}`] = `BIB Name for participant ${i + 1} has already been used.`;
              } else {
                bibNames.add(participant.bibName);
              }
            }
          }
        }
      }

      if (Object.keys(sanitizedErrors).length > 0) {
        const firstError = Object.values(sanitizedErrors)[0];
        setErrorMsg(firstError);
        showNotification("error", firstError);
        setFormData((prev) => ({ ...prev, errors: sanitizedErrors }));
        setLoading(false);
        return;
      }

      const updatedUserData = {
        namaDepan: sanitizedFormData.namaDepan,
        namaBelakang: sanitizedFormData.namaBelakang,
        namaLengkap: sanitizedFormData.namaLengkap,
        telepon: sanitizedFormData.telepon,
        nomorIdentitas: sanitizedFormData.nomorIdentitas,
        tanggalLahir: sanitizedFormData.tanggalLahir,
        gender: sanitizedFormData.gender,
        negara: sanitizedFormData.negara,
        provinsi: sanitizedFormData.provinsi,
        kota: sanitizedFormData.kota,
        alamat: sanitizedFormData.alamat,
        kontakDarurat: sanitizedFormData.kontakDarurat,
        namaKontakDarurat: sanitizedFormData.namaKontakDarurat,
        hubunganKontakDarurat: sanitizedFormData.hubunganKontakDarurat,
        bibName: isRaceEvent ? sanitizedFormData.bibName : undefined,
        golonganDarah:
          isRaceEvent ? sanitizedFormData.golonganDarah : undefined,
        sizeJersey:
          isRaceEvent ? sanitizedFormData.sizeJersey : undefined,
        performanceIndex:
          isRaceEvent ? sanitizedFormData.performanceIndex : undefined,
        raceResultLink:
          isJotrMainEvent ? sanitizedFormData.raceResultLink : undefined,
        certificateUrl:
          isJotrMainEvent ? sanitizedFormData.certificateUrl : undefined,
        riwayatMedis:
          isRaceEvent ? sanitizedFormData.riwayatMedis : undefined,
      };

      await updateUserData(updatedUserData);

      const userRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userRef);
      if (!userDoc.exists()) {
        throw new Error(
          "User data not found in Firestore after update."
        );
      }
      const userData = userDoc.data();

      const requiredUserFields = [
        "namaDepan",
        "namaBelakang",
        "bibName",
        "nomorIdentitas",
        "tanggalLahir",
        "golonganDarah",
        "sizeJersey",
        "gender",
        "kontakDarurat",
        "namaKontakDarurat",
        "hubunganKontakDarurat",
        "negara",
        "alamat",
        ...(userData.negara === "Indonesia" ? ["provinsi", "kota"] : []),
        ...(isJotrMainEvent ? ["raceResultLink"] : []),
      ];
      const missingUserFields = requiredUserFields.filter(
        (field) => !userData[field] || userData[field].trim() === ""
      );
      if (missingUserFields.length > 0) {
        throw new Error(
          `Incomplete user data: ${missingUserFields.join(", ")} is required.`
        );
      }

      if (!isRoadToJOTR) {
        await simpanSuratPernyataanSebagaiPDF();
      }

      const payload = {
        namaDepan: sanitizedFormData.namaDepan,
        namaBelakang: sanitizedFormData.namaBelakang,
        namaLengkap: sanitizedFormData.namaLengkap,
        email: sanitizedFormData.email,
        telepon: sanitizedFormData.telepon,
        nomorIdentitas: sanitizedFormData.nomorIdentitas,
        tanggalLahir: sanitizedFormData.tanggalLahir,
        gender: sanitizedFormData.gender,
        negara: sanitizedFormData.negara,
        provinsi: sanitizedFormData.provinsi,
        kota: sanitizedFormData.kota,
        alamat: sanitizedFormData.alamat,
        kontakDarurat: sanitizedFormData.kontakDarurat,
        namaKontakDarurat: sanitizedFormData.namaKontakDarurat,
        hubunganKontakDarurat: sanitizedFormData.hubunganKontakDarurat,
        bibName: isRaceEvent ? sanitizedFormData.bibName : undefined,
        golonganDarah:
          isRaceEvent ? sanitizedFormData.golonganDarah : undefined,
        sizeJersey:
          isRaceEvent ? sanitizedFormData.sizeJersey : undefined,
        performanceIndex:
          isRaceEvent ? sanitizedFormData.performanceIndex : undefined,
        raceResultLink:
          isJotrMainEvent ? sanitizedFormData.raceResultLink : undefined,
        certificateUrl:
          isJotrMainEvent ? sanitizedFormData.certificateUrl : undefined,
        riwayatMedis:
          isRaceEvent ? sanitizedFormData.riwayatMedis : undefined,
        kategori: isRaceEvent ? categoryName : undefined,
        seminar: eventId === "PelatihanPelatih" ? categoryName : undefined,
        distance: distance || 0,
        harga: Math.floor(finalPrice),
        eventId,
        voucherCode,
        uid: user.uid,
        collectionName,
        teamName: isGroupRegistration ? sanitizedFormData.teamName : undefined,
        participants: isGroupRegistration
          ? sanitizedFormData.participants.slice(1)
          : undefined,
        recaptchaToken, // NEW: Kirim token ke backend
      };

      const token = await getIdToken();
      const response = await axios.post(
        `${import.meta.env.VITE_API_BASE_URL}/api/register`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (finalPrice === 0) {
        const successMessage =
          "Registration successful! Your free registration has been confirmed.";
        setSuccessMsg(successMessage);
        showNotification("success", successMessage);
        setOrderId(response.data.orderId);
        const draftDocRef = doc(db, "registrations", `${user.uid}_${eventId}`);
        await deleteDoc(draftDocRef);
        setTimeout(
          () =>
            navigate(
              `/myregistration?order_id=${response.data.orderId}&transaction_status=settlement`
            ),
          2000
        );
        return;
      }

      const { orderId } = response.data;
      setOrderId(orderId);

      // OLD FLOW: Trigger Snap automatically
      // window.snap.pay(snapToken, { ... });

      // NEW FLOW: Redirect to waiting for verification (or qualified for ROADTOJOTR)
      const successMessage = isRoadToJOTR || isFunRun5K
        ? "Registration successful! Proceed to payment."
        : "Registration successful! Please wait for admin verification.";
      setSuccessMsg(successMessage);
      showNotification("success", successMessage, "Close");
      
      const draftDocRef = doc(
        db,
        "registrations",
        `${user.uid}_${eventId}`
      );
      await deleteDoc(draftDocRef);

      setTimeout(() => {
        navigate(
          isRoadToJOTR
            ? `/myregistration?order_id=${orderId}&status=qualified`
            : isFunRun5K
            ? `/myregistration?order_id=${orderId}&status=qualified`
            : `/myregistration?order_id=${orderId}&status=pending_verification`
        );
      }, 2000);

      // Remove dependency on snapToken for this step
      setSnapToken(null);

    } catch (error) {
      let errorMessage = "Registration failed. Please try again.";
      let errorDetails = "";
      if (error.response?.data) {
        errorMessage = error.response.data.message || "An error occurred on the server.";
        if (error.response.data.errors) {
          const errors = error.response.data.errors;
          if (errors.firstParticipant) {
            errorMessage =
              Object.values(errors.firstParticipant)[0] || errorMessage;
          } else if (errors.participant_1 || errors.participant_2) {
            errorMessage =
              Object.values(errors.participant_1 || errors.participant_2)[0] ||
              errorMessage;
          }
          errorDetails = JSON.stringify(errors, null, 2);
        }
      } else {
        errorMessage = error.message || errorMessage;
      }
      setErrorMsg(`${errorMessage}${errorDetails ? `: ${errorDetails}` : ""}`);
      showNotification(
        "error",
        `${errorMessage}${errorDetails ? `: ${errorDetails}` : ""}`
      );
    } finally {
      setLoading(false);
    }
  };

  const handleBayar = async () => {
    setLoading(true);
    setErrorMsg("");
    setSuccessMsg("");

    if (!isSnapReady || !window.snap) {
      setErrorMsg("Payment system not ready. Please try again.");
      showNotification(
        "error", 
        "Payment system not ready. Please try again.",
        "Close"
      );
      setLoading(false);
      return;
    }

    if (!snapToken || !orderId) {
      const msg = "Payment token or Order ID not found.";
      setErrorMsg(msg);
      showNotification("error", msg, "Close");
      setLoading(false);
      return;
    }

    try {
      window.snap.pay(snapToken, {
        onSuccess: async () => {
          const successMsgText = "Payment successful!";
          setSuccessMsg(successMsgText);
          showNotification("success", successMsgText, "Close");
          const draftDocRef = doc(
            db,
            "registrations",
            `${user.uid}_${eventId}`
          );
          await deleteDoc(draftDocRef);
          navigate(
            `/myregistration?order_id=${orderId}&transaction_status=settlement`
          );
        },
        onPending: async () => {
          const pendingMsgText = "Payment is being processed.";
          setSuccessMsg(pendingMsgText);
          showNotification("warning", pendingMsgText, "Close");
          navigate(
            `/myregistration?order_id=${orderId}&transaction_status=pending`
          );
        },
        onError: () => {
          setErrorMsg("Payment failed. Please try again.");
          showNotification(
            "error", 
            "Payment failed. Please try again.",
            "Close"
          );
          navigate(
            `/myregistration?order_id=${orderId}&transaction_status=failed`
          );
        },
        onClose: () => {},
      });
    } catch (err) {
      setErrorMsg("Failed to process payment. Please try again.");
      showNotification(
        "error", 
        "Failed to process payment.",
        "Close"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isSettled = transactionStatus === "settlement";
  const isPending = transactionStatus === "pending";
  const isAdminPending = transactionStatus === "pending" || transactionStatus === "qualified";
  const isFormDisabled = registrationStatus === "registered";

  return (
    <div className="min-h-screen bg-white px-4 ">
      <div className="max-w-5xl mx-auto py-20">
        {/* Header */}
       

        {/* Form Container */}
        <div className="bg-white rounded-xl border border-slate-200 p-4">
          {/* Title and Location */}
          <div className="mb-6">
            <h2 className="text-lg md:text-xl font-bold text-slate-800 uppercase">
              Jakarta Open Trail Run
            </h2>
            <div className="text-sm text-lime-600 mt-1 flex items-center gap-1">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
              </svg>
              Cibodas, West Java - Indonesia
            </div>
          </div>
          {/* Step Indicator - Inside Card */}
          <div className="mb-4">
            <div className="relative flex items-center justify-between">
              {/* Connecting Line Background */}
              <div className="absolute top-4 left-0 right-0 mx-6 h-0.5 bg-gray-200" />
              {/* Connecting Line Progress */}
              <div
                className="absolute top-4 left-0 mx-6 h-0.5 bg-lime-500 transition-all duration-500"
                style={{ width: `calc((100% - 3rem) * ${(currentStep - 1) / (STEPS.length - 1)})` }}
              />

              {/* Steps */}
              {STEPS.map((step, index) => {
                const stepNumber = index + 1;
                const isActive = stepNumber === currentStep;
                const isCompleted = stepNumber < currentStep;

                return (
                  <div
                    key={index}
                    className="flex flex-col relative items-center"
                  >
                    {/* Circle Wrapper - White background to mask the line locally */}
                    <div className="bg-white px-2 relative">
                      <div
                        className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-all duration-300 ${
                          isCompleted
                            ? "border-lime-500 bg-lime-500 text-white"
                            : isActive
                            ? "border-lime-500 bg-white text-lime-600"
                            : "border-gray-300 bg-white text-gray-400"
                        }`}
                      >
                        {isCompleted ? <FontAwesomeIcon icon={faCheck} className="text-xs" /> : stepNumber}
                      </div>
                    </div>
                    {/* Label - Outside the mask */}
                    <span
                      className={`text-xs font-medium mt-1 transition-colors text-center ${
                        isActive || isCompleted ? "text-lime-600" : "text-gray-400"
                      }`}
                    >
                      {step}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Step 1: Participant Info */}
          {currentStep === 1 && (
            <>
              <div className="mb-6 p-4 bg-slate-50 rounded-lg border border-slate-200">
                <h3 className="text-slate-800 font-semibold mb-1">
                  Event Registration
                </h3>
                <p className="text-slate-600 text-sm">
                  You are registering for <strong>Jakarta Open Trail Run</strong> in the <strong>{categoryName || title}</strong> category.
                </p>
              </div>
              
              <form id="form-pendaftaran" onSubmit={handleSubmit}>
                <InputFieldRace
                  formData={formData}
                  handleChange={handleChange}
                  isFormDisabled={isFormDisabled}
                  labelColor={labelColor}
                  eventId={eventId}
                  categoryName={categoryName}
                  updateUserData={updateUserData}
                  isForeigner={isForeigner}
                />
              </form>

              {/* Navigation */}
              <div className="flex justify-between items-center pt-8 border-t border-slate-200">
                <Button
                  variant="ghost"
                  onClick={() => navigate("/")}
                  className="text-slate-600 hover:text-slate-800"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleNextStep}
                  disabled={!checkStep1Validity()}
                  variant="primary"
                >
                  {isRoadToJOTR ? "Review & Submit →" : "Proceed to Waiver →"}
                </Button>
              </div>
            </>
          )}

          {/* Step 2: Waiver & Review (only for non-RoadToJOTR events) */}
          {currentStep === 2 && !isRoadToJOTR && (
            <>
              <div className="mb-6">
                <h2 className="text-xl font-bold text-slate-800 text-center mb-4">
                  {waiverContent.title}
                </h2>
                <div className="bg-white rounded-xl border border-slate-200 p-4 max-h-96 overflow-y-auto text-sm text-slate-700 leading-relaxed">
                  <p className="mb-4">{waiverContent.uiParagraphs[0]}</p>
                  <p className="mb-4">
                    {waiverContent.uiParagraphs[1]}
                    <strong>JAKARTA OPEN TRAIL RUN 2026</strong>
                    {waiverContent.uiParagraphs[2]}
                  </p>
                  <ol className="list-decimal list-inside space-y-3">
                    <li>
                      {waiverContent.uiList[0]}
                      <strong>JAKARTA OPEN TRAIL RUN 2026</strong>.
                    </li>
                    <li>
                      {waiverContent.uiList[1]}
                      <strong>JAKARTA OPEN TRAIL RUN 2026</strong>.
                    </li>
                    <li>{waiverContent.uiList[2]}</li>
                    <li>
                      {isForeigner ? "I realize that the " : "Saya menyadari bahwa lomba lari "}
                      <strong>JAKARTA OPEN TRAIL RUN 2026</strong>
                      {waiverContent.uiList[3]}
                    </li>
                    <li>
                      {isForeigner ? "I declare participating in the " : "Saya menyatakan berpartisipasi pada lomba "}
                      <strong>JAKARTA OPEN TRAIL RUN 2026</strong>
                      {waiverContent.uiList[4]}
                    </li>
                    <li>{waiverContent.uiList[5]}</li>
                    <li>{waiverContent.uiList[6]}</li>
                  </ol>
                </div>
              </div>

              {/* Checkbox Agreement */}
              <div className="bg-slate-100 rounded-lg p-4 mb-6">
                <InputField
                  type="checkbox"
                  id="waiver-agreement"
                  label={waiverContent.checkboxLabel}
                  checked={isChecked}
                  onChange={(e) => setIsChecked(e.target.checked)}
                  labelColor={labelColor}
                  labelClassName="text-sm font-medium"
                  className="gap-3"
                />
              </div>

              {/* Navigation */}
              <div className="flex justify-between items-center pt-6 border-t border-slate-200">
                <button
                  type="button"
                  onClick={handlePrevStep}
                  className="text-slate-600 hover:text-slate-800 font-medium h-10 flex items-center"
                >
                  Back
                </button>
                <Button
                  onClick={handleNextStep}
                  disabled={!isChecked}
                  variant="primary"
                  className="px-8"
                >
                  Agree & Continue →
                </Button>
              </div>
            </>
          )}

          {/* Step 2 (RoadToJOTR) or Step 3 (regular): Submission */}
          {(currentStep === 3 || (isRoadToJOTR && currentStep === 2)) && (
            <>


              {/* Status Description */}
              <div className="mb-4 p-3 rounded-lg text-sm bg-slate-50 text-slate-600 border border-slate-200">
                Review individual names and check identity numbers/emails. Data will be finalized upon submission.
              </div>

              <div className="grid grid-cols-2 md:grid-cols-12 gap-4 mb-4">
                <div className="col-span-2 md:col-span-4">
                  <div className="text-xs text-slate-400 mb-1">
                    Participant Name
                  </div>
                  <div className="text-base font-semibold text-slate-800">
                    {formData.namaLengkap || "-"}
                  </div>
                </div>
              </div>

              {/* Info Grid - Aligned 12-column strategy */}
              <div className="grid grid-cols-2 md:grid-cols-12 gap-4 py-4 border-t border-slate-100">
                <div className="col-span-2 md:col-span-4">
                  <div className="text-xs text-slate-400 mb-1">
                    Category
                  </div>
                  <div className="text-sm font-medium text-slate-700 md:whitespace-nowrap break-words">
                    {categoryName || title || "-"}
                  </div>
                </div>
                <div className="col-span-1 md:col-span-3">
                  <div className="text-xs text-slate-400 mb-1">
                    Jersey Size
                  </div>
                  <div className="text-sm font-medium text-slate-700">
                    {formData.sizeJersey || "-"}
                  </div>
                </div>
                <div className="col-span-1 md:col-span-3">
                  <div className="text-xs text-slate-400 mb-1">
                    Registration Fee
                  </div>
                  <div className="text-sm font-medium text-slate-700 md:whitespace-nowrap">
                    Rp {finalPrice.toLocaleString()}
                  </div>
                </div>
                <div className="col-span-2 md:col-span-2">
                  <div className="text-xs text-slate-400 mb-1">
                    Status
                  </div>
                  <div className="text-sm font-medium italic text-slate-500">
                    Ready to Submit
                  </div>
                </div>
              </div>

              {/* Note */}
              <div className="py-3 border-t border-slate-100">
                <p className="text-xs text-slate-400">
                  {isRoadToJOTR
                    ? "* Payment will be required immediately after submission."
                    : "* Payment will be made after the registration is verified by the admin"}
                </p>
              </div>

              {/* Error/Success Messages */}
              {(errorMsg || successMsg) && (
                <div className={`p-4 rounded-lg mb-4 ${
                  errorMsg ? "bg-red-50 text-red-700 border border-red-200" : "bg-lime-50 text-lime-700 border border-lime-200"
                }`}>
                  {errorMsg || successMsg}
                </div>
              )}

              {/* Navigation */}
              <div className="flex justify-between items-center pt-6 border-t border-slate-200">
                <button
                  type="button"
                  onClick={handlePrevStep}
                  className="text-slate-600 hover:text-slate-800 font-medium"
                >
                  Back
                </button>
                {isSettled ? (
                  <Button
                    variant="secondary"
                    className="bg-slate-400 text-white opacity-50 cursor-not-allowed"
                    disabled
                  >
                    Already Registered
                  </Button>
                ) : (
                <Button
                  onClick={handleSubmit}
                  disabled={loading}
                  variant="primary"
                >
                  {loading ? "Processing..." : "Submit Registration"}
                </Button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export const FormPendaftaran = (props) => (
  <GoogleReCaptchaProvider
    reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
    scriptProps={{
      async: true,
      defer: true,
      appendTo: "head",
    }}
  >
    <FormPendaftaranContent {...props} />
  </GoogleReCaptchaProvider>
);
